/**
 * FE-GS-PUT-1 — group share GET/PUT busy UX (DEF-BE-GS-503-001 FE leg).
 */

import { softApiError } from "./format.js";

/**
 * @param {unknown} err
 * @returns {boolean}
 */
export function isGroupShareDbBusyError(err) {
  const msg = String((err && err.message) || err || "");
  return msg.startsWith("503 ")
    || msg.includes("CONTROL_DB_BUSY")
    || msg.includes("database contended")
    || msg.includes("System busy");
}

/** @returns {string} */
export function groupShareDbBusyUserMessage() {
  return "The system is busy — wait 10–30 seconds and try Apply again.";
}

/**
 * @param {unknown} err
 * @returns {string}
 */
export function formatGroupShareApplyError(err) {
  if (isGroupShareDbBusyError(err)) return groupShareDbBusyUserMessage();
  return softApiError(err, "Could not update group share — try again shortly.");
}
